<script>
import Lock from '@/components/Utils/Lock.vue'
import {
    PreferenceService
} from '@/service/PreferenceService.js'
export default {
  abstract: true,
  props: ['item'],
  components:{
    Lock,
    PreferenceService
  },
  data: function() {
    return {
      options: [],
      content: '',
      defaultValue:'',
      reservedKeywords: ['title', 'description', 'prenom', 'nom', 'email'],
    }
  },
  watch: {
    content: function() {
      if(this.item.input != 'select'){
        this.setChanged();
      } 
    }
  },
  created() {
    if (this.item.default != null && this.item.input != 'checkbox') {
      this.content = this.item.default;
    }
    if (this.item.default != null && this.item.input == 'checkbox') {
      this.content.push(this.item.default);
    }
    this.options = JSON.parse(this.item.options);
    var wizard = this.getConfig('wizard');    
    
    if(wizard === 'dynamic-field'){
      var token = this.$cookie.get('gestionnaire');
      PreferenceService.query(token, this.item.default).then((response) => {
        var key = response.data.key;
        var value = response.data.value;

        this.content = '';
        this.default = '';

        response.data.data.forEach(element => {
          this.options.push({
            'key' : element[key], 
            'value' : element[value]
          });
        });
      })

      if (this.item.input == "select") {
        this.options = this.options.sort(function(valueA,valueB) {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
          if (valueA == valueB) return 0;
          return valueA < valueB ? -1 : 1;
        });
      }
    }

    this.setData();
  },
  methods: {
    shouldShow: function() {
      if (this.hidden === 1) {
        return false;
      }
      return true;
    },
    getConfig: function(key) {
      var config = JSON.parse(this.item.config);
      if (config.hasOwnProperty(key)) return config[key];
      return ''
    },
    setData: function() {
      var post = this.$store.state.post;
      if (post) {
        var wizard = this.getConfig('wizard');
        if (post.hasOwnProperty(wizard)) {
          this.content = post[wizard];
        } else {
          if (post.values && post.values.hasOwnProperty(this.item.key)) {
            this.content = post.values[this.item.key][0];
          }
        }
      }
    },
    setChanged() {
      var wizard = this.getConfig('wizard');
      var data = {
        'key': this.item.key,
        'content': this.content
      };
      if (wizard && this.reservedKeywords.indexOf(wizard) >= 0) {
        data['wizard'] = wizard
      }
      this.$emit('selected', data);
    }
  }
}
</script>
